import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const SkeletonContainer = styled.div`
  display: grid;
  gap: ${space[4]};
`;
